const ChevronXSIcon = (props) => (
  <svg width="6" height="4" {...props} className={`fill-current ${props?.className ? props?.className : ''}`} viewBox="0 0 6 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.00054 4.00009L0.171875 1.17143L1.11521 0.22876L3.00054 2.11476L4.88588 0.22876L5.82921 1.17143L3.00054 4.00009Z" />
  </svg>
);

export default ChevronXSIcon;
